import React, { useState } from 'react';
import { Container, PageBreadcrumbs } from 'common/components';
import { Hint, HintCloseButton, RegularButton, Typography, useMediaQuery } from 'fronton-react';
import {
	breadcrumbsStyles,
	HeaderBlock,
	hintBtnStyles,
	HintTextContent,
	PhoneLink,
	ServiceCenterContainer,
	FlexColumnBlock,
} from './styled';
import { QuestionIcon } from '@fronton/icons-react';
import { Paragraphs } from './components/paragraphs';
import {
	GOOD_NEWS,
	HOW_NOT_LOST_WARRANTY,
	PARAGRAPHS_TEXT,
	SOPHISTICATED_EQUIPMENT,
	TAKE_WITH_YOU,
	USEFUL_VISIT,
	WARRANTY,
} from './constants';
import { BayerCards, WarrantyCards } from './components/cards';
import { ListBlock } from './components/list-block';
import { SmallRequest } from './components/small-request';

export const ServiceCenter = () => {
	const isMobile = useMediaQuery('(max-width: 767px)');
	const [open, setOpen] = useState(false);
	const handleShow = () => setOpen(prev => !prev);
	return (
		<Container>
			<PageBreadcrumbs wrapperClassName={breadcrumbsStyles} />
			<ServiceCenterContainer>
				<FlexColumnBlock gap={32}>
					<HeaderBlock>
						<Typography variant="h1">Сервис и гарантия</Typography>
						<Hint
							open={open}
							anchor={
								<RegularButton
									aria-label="button with cat"
									onClick={handleShow}
									size="s"
									variant="pseudo"
									iconRight={<QuestionIcon />}
									className={hintBtnStyles}
								>
									Остались вопросы
								</RegularButton>
							}
							closeButton={<HintCloseButton onClick={handleShow} />}
							placement='bottom'
						>
							<HintTextContent>
								<Typography size="body_long" variant="s">
									Позвоните нам — 
								</Typography>
								<PhoneLink href="tel:+78007000099">8 800 700-00-99</PhoneLink>
							</HintTextContent>
						</Hint>
					</HeaderBlock>
					<Paragraphs data={PARAGRAPHS_TEXT} />
				</FlexColumnBlock>
				<FlexColumnBlock gap={32} marginTop={8}>
					<Typography variant="h2">Гарантия — это просто</Typography>
					<Paragraphs data={WARRANTY} />
					<WarrantyCards />
				</FlexColumnBlock>
				<ListBlock {...TAKE_WITH_YOU} />
				<SmallRequest />
				<ListBlock {...USEFUL_VISIT} />
				<FlexColumnBlock>
					<Typography size="subtitle" variant={isMobile ? 'm' : 'l'}>
						Отдельное внимание — сложное оборудование
					</Typography>
					<Paragraphs data={SOPHISTICATED_EQUIPMENT} />
				</FlexColumnBlock>
				<ListBlock {...HOW_NOT_LOST_WARRANTY} />
				<FlexColumnBlock>
					<Typography size="subtitle" variant={isMobile ? 'm' : 'l'}>
						И хорошая новость
					</Typography>
					<Paragraphs data={GOOD_NEWS} />
				</FlexColumnBlock>
				<FlexColumnBlock gap={32} marginTop={8}>
					<Typography variant="h2">Как забрать инструмент</Typography>
					<BayerCards />
				</FlexColumnBlock>
			</ServiceCenterContainer>
		</Container>
	);
};
